export enum SolarMountingSystem {
  PEG_S = 'PEG_S',
  PEG_EW = 'PEG_EW',
  FIXED_TILT = 'FIXED_TILT',
  FIXED_TILT_EW = 'FIXED_TILT_EW',
  VERTICAL_NS = 'VERTICAL_NS',
  FLOATING_TILT_S = 'FLOATING_TILT_S',
  FLOATING_TILT_EW = 'FLOATING_TILT_EW',
  AGRI_PV = 'AGRI_PV',
  AGRI_PV_LOW = 'AGRI_PV_LOW',
  TRACKER = 'TRACKER',
}
export const solarMountingSystemToLabel = {
  [SolarMountingSystem.PEG_S]: 'PEG South',
  [SolarMountingSystem.PEG_EW]: 'PEG East-West',
  [SolarMountingSystem.FIXED_TILT]: 'Fixed Tilt South',
  [SolarMountingSystem.FIXED_TILT_EW]: 'Fixed Tilt East-West',
  [SolarMountingSystem.VERTICAL_NS]: 'Vertical North-South',
  [SolarMountingSystem.FLOATING_TILT_S]: 'Floating South Tilt',
  [SolarMountingSystem.FLOATING_TILT_EW]: 'Floating East-West Tilt',
  [SolarMountingSystem.AGRI_PV]: 'Agri-PV (High)',
  [SolarMountingSystem.AGRI_PV_LOW]: 'Agri-PV (Low)',
  [SolarMountingSystem.TRACKER]: 'Tracker',
};
